module.exports = __webpack_public_path__ + "img/Benny.247a6a75.png";